import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../../../common-components/Button/Button';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { strings } from '../../../resources/strings';
import { IFilterToListLocationsOutput, YesNoFilter, yesNoFilterOptions } from '../locationUi';
import { ContainerBody, Row } from './styles';

interface IModalFiltersToListLocationsProps {
  appliedFilters: IFilterToListLocationsOutput;
  close: () => void;
  finish: (values: IFilterToListLocationsOutput) => void;
}

const ModalFiltersToListLocations: React.FC<IModalFiltersToListLocationsProps> = ({
  appliedFilters,
  close,
  finish
}) => {

  const [text, setText] = React.useState<string | undefined>(appliedFilters.text);
  const [omnichannel, setOmnichannel] = React.useState<YesNoFilter>(appliedFilters.omnichannel || YesNoFilter.All);
  const [manageOrderInSislog, setManageOrderInSislog] = React.useState<YesNoFilter>(appliedFilters.manageOrderInSislog || YesNoFilter.All);
  const [transactionalCommunication, setTransactionalCommunication] = React.useState<YesNoFilter>(appliedFilters.transactionalCommunication || YesNoFilter.All);

  return (
    <Modal
      show={true}
      onHide={() => close()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>
          {`${strings.Filter} ${strings.Locations}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '78vh' }}>
        <ContainerBody>
          <Row>
            <Field
              type={FieldType.Text}
              label={'Nome ou ID Shopify'}
              value={text}
              change={(value) => setText(value)}
              autoFocus={true}
              marginTop={'0px'}
              maxLength={250}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Omnichannel'}
              selectProps={{ options: yesNoFilterOptions, displayField: 'text', keyField: 'key' }}
              value={omnichannel}
              change={(value) => setOmnichannel(value)}
              marginTop={'0px'}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Usa Sislog para gestão de pedidos'}
              selectProps={{ options: yesNoFilterOptions, displayField: 'text', keyField: 'key' }}
              value={manageOrderInSislog}
              change={(value) => setManageOrderInSislog(value)}
              marginTop={'0px'}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.Select}
              label={'Comunicação transacional ativa'}
              selectProps={{ options: yesNoFilterOptions, displayField: 'text', keyField: 'key' }}
              value={transactionalCommunication}
              change={(value) => setTransactionalCommunication(value)}
              marginTop={'0px'}
            />
          </Row>
        </ContainerBody>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button text={strings.Cancel} click={() => close()} marginRight={'10px'} />
          <Button text={strings.Confirm} click={() => filter()} marginLeft={'10px'} />
        </div>
      </Modal.Footer>
    </Modal>
  );

  function filter() {
    finish({
      text: text?.trim() || undefined,
      omnichannel: omnichannel,
      manageOrderInSislog: manageOrderInSislog,
      transactionalCommunication: transactionalCommunication
    });
  }
}

export { ModalFiltersToListLocations };
